import type { CSSProperties } from 'react'
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline'

interface SearchBarProps {
  value: string
  onChange: (v: string) => void
  placeholder?: string
}

export default function SearchBar({ value, onChange, placeholder = 'Search…' }: SearchBarProps) {
  return (
    <div style={wrapStyle}>
      <MagnifyingGlassIcon style={{ width: 14, color: 'var(--text-muted)', flexShrink: 0 }} />
      <input
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        style={inputStyle}
      />
      {value && (
        <button onClick={() => onChange('')} style={clearBtn}>
          <XMarkIcon style={{ width: 12 }} />
        </button>
      )}
    </div>
  )
}

const wrapStyle: CSSProperties = {
  display: 'flex', alignItems: 'center', gap: '8px',
  background: 'var(--surface)',
  border: '1px solid var(--border)',
  borderRadius: '8px',
  padding: '7px 10px',
}

const inputStyle: CSSProperties = {
  flex: 1, background: 'none', border: 'none', outline: 'none',
  color: 'var(--text)', fontSize: '13px',
}

const clearBtn: CSSProperties = {
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  background: 'none', border: 'none', padding: 0,
  color: 'var(--text-muted)', cursor: 'pointer', flexShrink: 0,
}
